import React from "react";
import "./radiobutton.css";

class RadioButton extends React.Component{
  constructor (props){
    super(props);
  }

  render(){
    return(
      <div className="radio">
        <label>
          <input className={this.props.classes} onClick={this.props.onClick} type="checkbox" value={this.props.value} name={this.props.name}/>
          <span className="radio-title">{this.props.title}</span>
        </label>
      </div>
    )
  }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/form/RadioButton.js